import { PageLoadError } from '@components/page-load-error';
import { createFileRoute } from '@tanstack/react-router';
import HighYieldSavingsLayout from './-layouts/-high-yield-savings-layout';

export const Route = createFileRoute(
  '/_authenticated/dashboard/high-yield-savings/',
)({
  // loader: async ({ context }) => {
  //   await Promise.all([
  //     context.queryClient.ensureQueryData(getProductsQueryOptions),
  //     context.queryClient.ensureQueryData(getAccountsQueryOptions),
  //   ]);
  //   return null; // don't return derived data; just ensure cache is warm
  // },
  errorComponent: (error) => (
    <PageLoadError pageName='High-Yield Savings' error={error} />
  ),
  component: HighYieldSavingsLayout,
});
